import React from "react";
import { IonIcon } from "@ionic/react";
import { closeCircleOutline } from "ionicons/icons";
import Button from "../../../../../sharable/ActionButton";
import { Selector } from "../../../../../sharable/PickerAndSelector";
import { TakeXPayYPromoFloatWindow } from "./TakeXPayYModal.styles";
import { useTakeXPayYModal } from "./useTakeXPayYModal";

export const TakeXPayYModal = ({
  isOpen,
  products,
  currentProductId,
  currentProductName,
  isAccountPremium,
  onClose,
  onSave,
}) => {
  const {
    productAdvancedFields,
    updateProductAdvancedFields,
    isPayYBigger,
    parsePrice,
    save,
    takeXPayYOptions,
  } = useTakeXPayYModal({
    products,
    currentProductId,
    isOpen,
    onSave,
  });

  if (!isOpen) return null;

  return (
    <TakeXPayYPromoFloatWindow
      className="flex direction-column"
      isAccountPremium={isAccountPremium}
    >
      <div className="icon-wrapper flex min-gap align" onClick={onClose}>
        <span>Fechar</span>
        <IonIcon icon={closeCircleOutline} className="icon" />
      </div>

      <span className="edit-product-span">
        Editando <strong>'{currentProductName}'</strong>
      </span>

      <h1>Leve X, Pague Y</h1>
      <p>
        Você pode montar sua promoção como “Leve 5, pague 4 por R$19,99 ou
        apenas “Leve 4 por R$19,99”.
      </p>

      <div className="promo-fields-list flex direction-column justify-left">
        <div className="flex direction-column">
          <h2>Leve X</h2>
          <Selector
            txt={""}
            callback={(option) => {
              const selected = option === "-" ? undefined : option;
              updateProductAdvancedFields("takeX", selected);
            }}
            options={takeXPayYOptions}
            selected={productAdvancedFields.takeX}
          />
        </div>

        <div className="flex direction-column">
          <h2>Pague Y (Opcional)</h2>
          {isPayYBigger && <p>Pague Y não pode ser maior que Leve X</p>}
          <Selector
            txt={""}
            callback={(option) => {
              const selected = option === "-" ? undefined : option;
              updateProductAdvancedFields("payY", selected);
            }}
            options={takeXPayYOptions}
            selected={productAdvancedFields.payY}
            customClassName={isPayYBigger && "invalid-input"}
          />
        </div>

        <div className="flex direction-column">
          <h2>Valor promocional</h2>
          <input
            onInput={(e) => {
              const parsedPrice = parsePrice(e.target.value);
              if (parsedPrice) {
                updateProductAdvancedFields("promotionPrice", parsedPrice);
              }
            }}
            type="text"
            placeholder="Ex: 19,99"
            value={productAdvancedFields.promotionPrice}
          />
        </div>
      </div>

      {productAdvancedFields.takeX == null ||
        (!isPayYBigger && (
          <Button
            color={"#fff"}
            text={"Salvar"}
            width={"35%"}
            $fullWidth={true}
            action={save}
          />
        ))}
    </TakeXPayYPromoFloatWindow>
  );
};
